export default function setofferingheight() {
	document.addEventListener('DOMContentLoaded', function () {
		function isDesktop() {
			return window.matchMedia('(min-width: 768px)').matches;
		}
		if (isDesktop()) {
			const rightContent = document.querySelector(
				'body .build-to-learn-wrapper .build-to-learn-block .rht-content',
			)?.offsetHeight;
			const leftContent = document.querySelector(
				'body .build-to-learn-wrapper .build-to-learn-block .lft-content',
			)?.offsetHeight;
			const largerHeight = leftContent > rightContent ? leftContent : rightContent;
			if (document.querySelector('body .build-to-learn-wrapper')) {
				document.querySelector('body .build-to-learn-wrapper').style.height = `${largerHeight}px`;
				if (rightContent > leftContent) {
					document.querySelector('.build-to-learn-wrapper').classList.add('mb-55');
				}
			}
		}
	});
}
